export const getStateToDropdownInbox = state => {
  const dropdown = [];
  Object.keys(state).forEach(key => {
    dropdown.push({ active: state[key].active, value: key });
  });
  return dropdown;
};

export const getActiveState = state => {
  let activeState = {};
  Object.keys(state).forEach(key => {
    if (state[key].active === true) {
      activeState = { value: key, trackLabel: state[key].trackLabel, status: state[key].status };
    }
  });
  return activeState;
};
